/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { BufferedChangeset } from "ember-changeset/types";

import styles from "./index.module.css";

interface Signature {
  Element: HTMLDivElement;
  Args: {
    currentSelection?: unknown;
    title?: unknown;
    propertyName: string;
    changeset: BufferedChangeset;
  };
}

export default class ArticulationFormComponent extends Component<Signature> {
  styles = styles;

  @action
  onChange(label) {
    const propertyName = this.args.propertyName;
    let value = this.args.changeset.get(propertyName);
    if (value?.includes(label)) {
      value = value.filter(values => values != label);
    } else {
      value = value.concat(label);
    }
    this.args.changeset.set(propertyName, value);
  }
}
